import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import { useCommentsRoot } from '../Root';
import SubscriptionSwitch from '../SubscriptionSwitch';

const Sort = dynamic(() => import('./Sort'));
const EmptyCommentsList = dynamic(
  () => import('./../../CommentsList/EmptyCommentsList'),
  {
    ssr: false,
  }
);

const Header = ({
  children = null,
  emptyListComponent: EmptyListComponent = null,
  isSortActive = true,
  isSubscribed,
  onSubscribe,
}) => {
  const { isCommentsListEmpty } = useCommentsRoot();

  return (
    <>
      <div className="flex items-end justify-between md:items-center">
        <div className="flex flex-col justify-start gap-x-4 lg:flex-row">
          {isSortActive && <Sort />}
        </div>
        <SubscriptionSwitch
          isSubscribed={isSubscribed}
          onSubscribe={onSubscribe}
        />
      </div>
      {children}
      {isCommentsListEmpty && EmptyListComponent && <EmptyCommentsList />}
    </>
  );
};

Header.propTypes = {
  children: PropTypes.node,
  emptyListComponent: PropTypes.shape(),
  isSortActive: PropTypes.bool,
};

export default Header;
